import { useTranslation } from 'react-i18next';
import Lottie from 'lottie-react';

import useClickEnter from '@/shared/hooks/useClickEnter';
import useResponsive from '@/shared/hooks/useResponsive';

import ControlBar from '@/features/timeGame/components/common/ControlBar';
import Button from '@/shared/components/button/Button';
import Tooltip, { TooltipColors, TooltipSizes } from '@/shared/components/tooltip/Tooltip';

import BackgroundMobile from '@/features/timeGame/assets/images/start-screen-background-mobile.svg?react';
import Background from '@/features/timeGame/assets/images/start-screen-background.svg?react';
import qSpaceDefault from '@/features/timeGame/assets/lottie/q-space-default.json';

import '@/features/timeGame/styles/time-game-start-screen.scss';

interface Props {
	onStart: () => void;
	onBack: () => void;
}

const TOOLTIP_ANCHOR_ID = 'time-game-start-screen__character';

const StartScreen = ({ onStart, onBack }: Props) => {
	const { t } = useTranslation();
	const { isPortrait } = useResponsive();

	useClickEnter(onStart);

	const BackgroundComponent = isPortrait ? BackgroundMobile : Background;

	return (
		<div className="time-game-start-screen" role="dialog" aria-modal="true" aria-label="Time Game Start Screen">
			<div className="time-game-start-screen__background">
				<BackgroundComponent />
			</div>

			<div className="time-game-start-screen__controls">
				<ControlBar onBack={onBack} isAudioTooltipOpen small />
			</div>

			<div className="time-game-start-screen__button">
				<Button type="primary" iconName="icon-play" title="Start" onClick={onStart} />
			</div>

			<Lottie
				id={TOOLTIP_ANCHOR_ID}
				animationData={qSpaceDefault}
				loop
				autoplay
				className="time-game-start-screen__character"
				aria-hidden="true"
			/>

			<Tooltip
				place="top"
				title={t('time_game.start_screen.tooltip')}
				anchor={TOOLTIP_ANCHOR_ID}
				color={TooltipColors.LIGHT}
				size={TooltipSizes.LARGE}
				className="time-game-start-screen__tooltip"
				isOpen
			/>
		</div>
	);
};

export default StartScreen;
